if (!customElements.get("christmas-2025-gift-time-joy")) {
  customElements.define('christmas-2025-gift-time-joy',
    class extends HTMLElement {
      constructor() {
        super();
        this.swiperInstance = null;
      }

      connectedCallback() {
        this.swiperButtonContainer = this;
        this.initSwiper();
      }

      initSwiper() {
        const swiperContainer = this.querySelector('.swiper');
        let swiperNextButton, swiperPrevButton;
        if (this.swiperButtonContainer) {
          swiperNextButton = this.swiperButtonContainer.querySelector('.swiper-button-next');
          swiperPrevButton = this.swiperButtonContainer.querySelector('.swiper-button-prev');
        }


        if (swiperContainer) {
          this.swiperInstance = new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            navigation: {
              nextEl: swiperNextButton || undefined,
              prevEl: swiperPrevButton || undefined,
            },
          });
        } else {
          console.error("Swiper container not found.");
        }
      }


      disconnectedCallback() {
      }
    });
}
